module.exports = __webpack_public_path__ + "img/maria.78cc343c.svg";